import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const Renew = ({
	stroke = '#4A4A4A',
	...props
}) => (
	<svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
		<path
			d="M1 1v5h.582m15.356 2A8.001 8.001 0 001.582 6m0 0H6m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H12"
			stroke={stroke}
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const RenewThick = ({
	width,
	height,
	fill,
	...props
}) => (
	<svg width={width} height={height} viewBox="0 0 14 15" fill="none" {...props}>
		<path
			d="m11.708 3.115 1.87-1.87.214-.213v6.26h-6.26l.213-.214 2.594-2.594A4.796 4.796 0 0 0 7 3.125 4.879 4.879 0 0 0 2.125 8 4.879 4.879 0 0 0 7 12.875a4.867 4.867 0 0 0 4.59-3.25l.03-.083h1.983l-.04.156c-.756 2.928-3.396 5.094-6.563 5.094A6.783 6.783 0 0 1 .217 8 6.783 6.783 0 0 1 7 1.208l4.708 1.907Zm0 0A6.756 6.756 0 0 0 7 1.208l4.708 1.907Z"
			fill={fill}
			stroke={fill}
			strokeWidth={0.25}
		/>
	</svg>
);

RenewThick.propTypes = {
	fill: PropTypes.string,
	width: PropTypes.number,
	height: PropTypes.number,
};
RenewThick.defaultProps = {
	width: 14,
	height: 15,
	fill: getColor('primaryBrand'),
};

export default Renew;
